import { render, staticRenderFns } from "./PaymentTariffUnknown.vue?vue&type=template&id=6ded1390&scoped=true&"
import script from "./PaymentTariffUnknown.vue?vue&type=script&lang=js&"
export * from "./PaymentTariffUnknown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded1390",
  null
  
)

export default component.exports